import React from "react";
import { useNavigate } from "react-router-dom";
import { TypeOfApplicationEnum } from "../../utils/enum";
import moment from "moment";
import { dashboardNavConfig } from "./LabGridRow";
import { NotifyType } from "../../utils/app-config";
import { notify } from "../../utils";
const SaveDraftLabGridRow = ({
  data,
  sno,
  onCheckboxChange,
  isChecked,
}: any) => {
  const navigate = useNavigate();
  const { message } = notify();
  const navToSamples = (
    appNum: string,

    purposeCode?: string
  ) => {
    if (!purposeCode) {
      message(NotifyType.Error, "Purpose code is Empty");
      return;
    }
    navigate(
      `/${dashboardNavConfig[purposeCode]}?an=${appNum}&type=${TypeOfApplicationEnum.draft}`
    );
  };
  return (
    <tr>
      <td>{data?.sno || ""}</td>
      <td>{data?.purposeCode || ""}</td>

      <td>
        <a
          href=""
          onClick={() =>
            navToSamples(data?.applicationNumber, data?.purposeCode)
          }
        >
          {data?.applicationNumber || ""}
        </a>
      </td>

      <td>{data?.requestorName || ""}</td>

      <td>
        {data?.applicationDate
          ? moment(data?.applicationDate).format("DD/MM/yyyy")
          : ""}
      </td>

      <td>
        <a>Draft</a>
      </td>
      <td>
        <input
          type="checkbox"
          checked={isChecked}
          onChange={() => onCheckboxChange(data?.applicationNumber)}
        />
      </td>
    </tr>
  );
};

export default SaveDraftLabGridRow;
